<script setup lang="ts">
import type { AutoCompleteType } from '@apps/main/new-desktop/modules/autoComplete';
import type { EditTripSegment } from '@apps/main/new-desktop/modules/editTripModal';

import { AppButton } from '@libs/ui';

import EditTripSegments from './EditTripSegments.vue';

interface ExtendedCarTripSegmentsProps {
  segments: EditTripSegment[];
}
const props = defineProps<ExtendedCarTripSegmentsProps>();

interface ExtendedCarTripSegmentsEmits {
  (
    eventName: 'change-destination',
    payload: {
      segment: EditTripSegment;
      autocomplete:
        | AutoCompleteType.Destination
        | AutoCompleteType.StartingPosition
        | AutoCompleteType.EndingPosition;
    }
  ): void;
  (eventName: 'change-trip-order', segments: EditTripSegment[]): void;
  (eventName: 'change-number-of-nights', data: EditTripSegment): void;
  (eventName: 'remove-destination', segment: EditTripSegment): void;
  (eventName: 'open-add-destination-step'): void;
}
const emit = defineEmits<ExtendedCarTripSegmentsEmits>();
</script>

<template>
  <EditTripSegments
    :segments="props.segments"
    @change-trip-order="emit('change-trip-order', $event)"
    @change-number-of-nights="emit('change-number-of-nights', $event)"
    @change-destination="emit('change-destination', $event)"
    @remove-destination="emit('remove-destination', $event)"
  />
  <AppButton
    class="add-destination-button"
    type="secondary"
    state="enabled"
    size="small"
    :left-icon="{ name: 'plus' }"
    @click="emit('open-add-destination-step')"
  >
    {{ $t('planner.add_destination') }}
  </AppButton>
</template>

<style scoped lang="scss">
.add-destination-button {
  margin-left: 36px;
  margin-top: var(--spacing-24);
}
</style>
